import { invokeApi } from "../../bl_libs/invokeApi";

export const get_color_scheme_api = async (signal = null) => {
  const requestObj = {
    path: `api/color_scheme`,
    method: "GET",
    signal,
    skip401Handler: true,
  };
  return invokeApi(requestObj);
};

export const update_color_scheme_api = async (data) => {
  const requestObj = {
    path: `api/color_scheme`,
    method: "PUT",
    postData: data,
  };
  return invokeApi(requestObj);
};
